<template>
  <div class="container">
    <p><img src="@/assets/Quest_long_logo.png"></p>

    <section style="margin-top: 2em">
      <p class="title">Get Quest Here -- Sign Up or Reactivate</p>
    </section>

    <h2
      class="subtitle"
      v-if="trialPeriod != 'Days14'"
    >
      Start your free trial here
    </h2>
    <p
      v-if="trialPeriod == 'Days14'"
      class="is-size-4 is-success"
      style="background-color: #FFFFAA;"
    >
      Yay! You are getting the special 14 day free trial :)
    </p>

    <section style="margin-top: 2em">
      <b-steps
        v-model="activeStep"
        type="is-success"
        :has-navigation="false"
        @input="resetSteps()"
      >
        <b-step-item
          label="Validate Membership"
          :visible="visibleSteps.validation"
        >
          <p
            class="subtitle"
            style="margin-top: 2em"
          >
            Let's verify your membership with Lifestyles Unlimited.
          </p>
          <b-field label="Your Lifestyles Unlimited Email">
            <b-input
              v-model="emailToValidate"
              type="email"
              value=""
              maxlength="100"
              placeholder="Email on file with Lifestyles Unlimited"
            ></b-input>
          </b-field>

          <b-button
            class="is-primary"
            @click="isMember(emailToValidate)"
          >Verify Email</b-button>

        </b-step-item>

        <b-step-item
          label="Subscribe"
          :visible="visibleSteps.signUp"
        >
          <p
            class="subtitle has-text-weight-semibold"
            style="margin-top: 2em"
          >
            Payment Information
          </p>
          <p class="header has-text-weight-semibold">
            Your credit card will not be charged at this time.
          </p>
          <p class="header">
            Your free trial will end on
            {{ trialEndDate | date }}.
          </p>
          <p>
            Your card will not be charged before that date and you can cancel
            anytime before or after the trial.
          </p>
          <p>
            The monthly subscription cost is
            {{ productStatus.price | currency(0) }}.
          </p>

          <div
            v-if="productStatus.nextCall == 'CreateSubscription'"
            style="margin-top: 2em"
          >
            <p
              class="subtitle has-text-weight-semibold"
              style="margin-top: 2em"
            >
              Please enter your account information here
            </p>
            Account Information

            <div class="columns">
              <div class="column field">
                <div class="control">
                  <input
                    @focus="$event.target.select()"
                    class="input"
                    v-bind:class="{
                      'is-danger': !$v.firstName.required && $v.firstName.$error
                    }"
                    type="text"
                    placeholder="First name"
                    v-model.trim="$v.firstName.$model"
                  />
                </div>
              </div>

              <div class="column field">
                <div class="control">
                  <input
                    @focus="$event.target.select()"
                    class="input"
                    v-bind:class="{
                      'is-danger': !$v.lastName.required && $v.lastName.$error
                    }"
                    type="text"
                    placeholder="Last name"
                    v-model.trim="$v.lastName.$model"
                  />
                </div>
              </div>

              <div class="column field">
                <div class="control">
                  <b-field :type="passwordCheck($v)">
                    <b-input
                      @focus="$event.target.select()"
                      type="password"
                      v-model.trim="$v.password.$model"
                      password-reveal
                      placeholder="Create Password"
                    />
                  </b-field>
                </div>
                <div
                  class="help is-danger"
                  v-if="!$v.password.minLength"
                >
                  Password must be at least
                  {{ $v.password.$params.minLength.min }} characters long
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="
              productStatus.nextCall == 'AddSubscriptionWithCC' ||
                productStatus.nextCall == 'CreateSubscription'
            "
            style="margin-top: 2em"
          >
            <p
              class="subtitle has-text-weight-semibold"
              style="margin-top: 2em"
            >
              Please enter your credit card information
            </p>
            Credit Card Information

            <div class="columns">
              <div class="column field">
                <div class="control">
                  <input
                    @focus="$event.target.select()"
                    class="input"
                    v-bind:class="{
                      'is-danger':
                        !$v.firstNameOnCard.required &&
                        $v.firstNameOnCard.$error
                    }"
                    type="text"
                    placeholder="First name on card"
                    value=""
                    v-model.trim="$v.firstNameOnCard.$model"
                  />
                </div>
              </div>

              <div class="column field">
                <div class="control">
                  <input
                    @focus="$event.target.select()"
                    class="input"
                    v-bind:class="{
                      'is-danger':
                        !$v.lastNameOnCard.required && $v.lastNameOnCard.$error
                    }"
                    type="text"
                    placeholder="Last name on card"
                    v-model.trim="$v.lastNameOnCard.$model"
                  />
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column field">
                <div class="control">
                  <input
                    @focus="$event.target.select()"
                    class="input"
                    v-bind:class="{
                      'is-danger':
                        (!$v.ccNumber.required || !$v.ccNumber.numeric) &&
                        $v.ccNumber.$error
                    }"
                    type="text"
                    placeholder="Credit card number (no spaces)"
                    v-model.trim="$v.ccNumber.$model"
                  />
                </div>
              </div>

              <div class="column field">
                <div class="control">
                  <input
                    @focus="$event.target.select()"
                    class="input"
                    v-bind:class="{
                      'is-danger':
                        (!$v.cvv.required || !$v.cvv.numeric) && $v.cvv.$error
                    }"
                    type="text"
                    placeholder="CVV"
                    value=""
                    v-model.trim="$v.cvv.$model"
                  />
                </div>
              </div>

              <div class="column field">
                <div class="control">
                  <input
                    @focus="$event.target.select()"
                    class="input"
                    v-bind:class="{
                      'is-danger':
                        (!$v.expirationMonth.required ||
                          !$v.expirationMonth.numeric ||
                          $v.expirationMonth.minLength ||
                          $v.expirationMonth.maxLength) &&
                        $v.expirationMonth.$error
                    }"
                    type="text"
                    placeholder="MM (Month)"
                    value=""
                    v-model.trim="$v.expirationMonth.$model"
                  />
                </div>
                <div
                  class="help is-danger"
                  v-if="!$v.expirationMonth.numeric && !$v.cvv.$error"
                >
                  Only numbers are allowed
                </div>
                <div
                  class="help is-danger"
                  v-if="!$v.expirationMonth.minLength && !$v.cvv.$error"
                >
                  Must be 2 numbers long
                </div>
                <div
                  class="help is-danger"
                  v-if="!$v.expirationMonth.maxLength && !$v.cvv.$error"
                >
                  Must be 2 numbers long
                </div>
              </div>

              <div class="column field">
                <div class="control">
                  <input
                    @focus="$event.target.select()"
                    class="input"
                    v-bind:class="{
                      'is-danger':
                        (!$v.expirationYear.required ||
                          !$v.expirationYear.numeric ||
                          $v.expirationYear.minLength ||
                          $v.expirationMonth.maxLength) &&
                        $v.expirationYear.$error
                    }"
                    type="text"
                    placeholder="YYYY (Year)"
                    value=""
                    v-model.trim="$v.expirationYear.$model"
                  />
                </div>
                <div
                  class="help is-danger"
                  v-if="!$v.expirationYear.numeric && !$v.cvv.$error"
                >
                  Only numbers are allowed
                </div>
                <div
                  class="help is-danger"
                  v-if="!$v.expirationYear.minLength && !$v.cvv.$error"
                >
                  Must be 4 numbers long
                </div>
                <div
                  class="help is-danger"
                  v-if="!$v.expirationYear.maxLength && !$v.cvv.$error"
                >
                  Must be 4 numbers long
                </div>
              </div>
            </div>

            <div class="level">
              <b-checkbox v-model="agreed">I agree to the <router-link :to="{ name: 'PrivacyPolicy'}">policies</router-link> and <router-link :to="{ name: 'TermsAndConditions'}">terms</router-link>
              </b-checkbox>
            </div>

            <b-button
              v-if="productStatus.nextCall == 'AddSubscriptionWithCC'"
              :disabled="!agreed"
              class="is-primary"
              @click="addSubscriptionWithCC()"
            >Start My Subscription</b-button>

            <b-button
              v-if="productStatus.nextCall == 'CreateSubscription'"
              class="is-primary"
              :disabled="!agreed"
              @click="createSubscription()"
            >Start My Subscription</b-button>
          </div>

          <div
            v-if="productStatus.nextCall == 'AddSubscriptionNoCC'"
            style="margin-top: 2em"
          >
            <p
              class="subtitle"
              style="margin-top: 2em"
            >
              To subscribe to Quest please enter your password.
            </p>
            <b-field label="Your Lifestyles Quest or BasilBooks Password">
              <b-input
                v-model="passwordToValidate"
                type="password"
                value=""
                maxlength="100"
                placeholder="Password"
              ></b-input>
            </b-field>

            <div class="level">
              <b-checkbox v-model="agreed">I agree to the <router-link :to="{ name: 'PrivacyPolicy'}">policies</router-link> and <router-link :to="{ name: 'TermsAndConditions'}">terms</router-link>
              </b-checkbox>
            </div>

            <b-button
              :disabled="!agreed"
              class="is-primary"
              @click="addSubscriptionNoCC()"
            >Subscribe</b-button>
          </div>
        </b-step-item>

        <b-step-item
          label="Reactivate"
          :visible="visibleSteps.reactivate"
        >
          <p
            class="subtitle has-text-weight-semibold"
            style="margin-top: 2em"
          >
            Payment Information
          </p>
          <p>
            The monthly subscription cost is
            {{ productStatus.price | currency(0) }}.
          </p>

          <p
            class="subtitle"
            style="margin-top: 2em"
          >
            To reactivate your subscription please enter your password.
          </p>
          <b-field label="Your Lifestyles Quest or BasilBooks Password">
            <b-input
              v-model="passwordToValidate"
              type="password"
              value=""
              maxlength="100"
              placeholder="Password"
            ></b-input>
          </b-field>

          <b-button
            class="is-primary"
            @click="reactivate()"
          >Reactivate My Subscription</b-button>
        </b-step-item>

        <b-step-item
          label="Resume"
          :visible="visibleSteps.resume"
        >
          <p
            class="subtitle has-text-weight-semibold"
            style="margin-top: 2em"
          >
            Payment Information
          </p>
          <p>
            The monthly subscription cost is
            {{ productStatus.price | currency(0) }}.
          </p>

          <p
            class="subtitle"
            style="margin-top: 2em"
          >
            To resume your subscription please enter your password.
          </p>
          <b-field label="Your Lifestyles Quest or BasilBooks Password">
            <b-input
              v-model="passwordToValidate"
              type="password"
              value=""
              maxlength="100"
              placeholder="Password"
            ></b-input>
          </b-field>

          <b-button
            class="is-primary"
            @click="resume()"
          >Resume My Subscription</b-button>
        </b-step-item>

        <b-step-item
          label="Done"
          :visible="visibleSteps.confirmation"
        >
          <p
            class="subtitle"
            style="margin-top: 2em"
          >
            Your subscription is active and ready to go! Click Sign In.
          </p>
          <b-button
            class="is-primary"
            @click="signin()"
          >Sign In</b-button>
        </b-step-item>

        <b-step-item
          label="Sign In"
          :visible="visibleSteps.signIn"
        >
          <p
            class="subtitle"
            style="margin-top: 2em"
          >
            Good news, your subscription to Quest is already active!
          </p>
          <p>Press the Sign In button to access it.</p>
          <b-button
            class="is-primary"
            @click="signin()"
          >Sign In</b-button>
        </b-step-item>
      </b-steps>
    </section>

    <div style="padding-bottom: 100px"></div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  email,
  numeric
} from "vuelidate/lib/validators";
import moment from "moment";
import Divider from "bulma-divider/dist/css/bulma-divider.min.css";
import AuthenticatorService from "@/services/AuthenticatorService.js";

export default {
  validations: {
    firstName: {
      required
    },
    lastName: {
      required
    },
    email: {
      email,
      required
    },
    password: {
      required,
      minLength: minLength(4)
    },
    firstNameOnCard: {
      required
    },
    lastNameOnCard: {
      required
    },
    ccNumber: {
      required,
      numeric
    },
    cvv: {
      required,
      numeric
    },
    expirationMonth: {
      required,
      numeric,
      minLength: minLength(2),
      maxLength: maxLength(2)
    },
    expirationYear: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4)
    }
  },

  data() {
    return {
      // firstName: 'A',
      // lastName: 'A',
      // email: 'a@a.com',
      // password: 'aaaa',
      // firstNameOnCard: 'BB',
      // lastNameOnCard: 'BB',
      // ccNumber: '4111111111111111',
      // cvv: '123',
      // expirationMonth: '02',
      // expirationYear: '2020',
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      firstNameOnCard: "",
      lastNameOnCard: "",
      ccNumber: "",
      cvv: "",
      expirationMonth: "",
      expirationYear: "",
      trialEndDate: moment()
        .add(7, "days")
        .calendar(),
      agreed: false,
      trialPeriod: "Days7",
      trialPeriodDays: -1,
      activeStep: 0,
      emailToValidate: "",
      passwordToValidate: "",
      validEmail: false,
      visibleSteps: {
        validate: true,
        signUp: true,
        reactivate: false,
        resume: false,
        confirmation: true,
        signIn: false
      },
      productStatus: {
        billingPortalUrl: "",
        subscriptionStatus: "",
        signInUrl: "",
        nextCall: "",
        price: 0.0,
        interval: 0,
        intervalUnit: "",
        trialInterval: 0,
        trialIntervalUnit: "",
        trialEndDate: undefined
      }
    };
  },

  components: { Divider },

  methods: {
    addSubscriptionNoCC() {
      this.$store.commit("SET_LOADING_STATUS_NODELAY", true);
      AuthenticatorService.addSubscriptionNoCC(
        this.emailToValidate,
        this.passwordToValidate,
        "Quest"
      )
        .then(response => {
          console.log("TCL: addSubscriptionNoCC -> response", response);
          this.$store.commit("SET_LOADING_STATUS_NODELAY", false);
          this.activeStep = 4;
        })
        .catch(error => {
          this.$store.commit("SET_LOADING_STATUS_NODELAY", false);
          if (error && error.response && error.response.data)
            this.showError(error.response.data);
          else this.showError(error);
        });
    },

    addSubscriptionWithCC() {
      this.$store.commit("SET_LOADING_STATUS_NODELAY", true);
      AuthenticatorService.addSubscriptionWithCC(
        this.emailToValidate,
        "Quest",
        this.firstNameOnCard,
        this.lastNameOnCard,
        this.ccNumber,
        this.cvv,
        this.expirationMonth,
        this.expirationYear
      )
        .then(response => {
          console.log("TCL: addSubscriptionWithCC -> response", response);
          this.$store.commit("SET_LOADING_STATUS_NODELAY", false);
          this.activeStep = 4;
        })
        .catch(error => {
          this.$store.commit("SET_LOADING_STATUS_NODELAY", false);
          if (error && error.response && error.response.data)
            this.showError(error.response.data);
          else this.showError(error);
        });
    },

    createSubscription() {
      console.log("createSubscription!");
      this.email = this.emailToValidate;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.showError("ERROR");
      } else {
        this.$store.commit("SET_LOADING_STATUS_NODELAY", true);
        this.trialPeriodDays = 7;
        if (this.trialPeriod == "Days14") this.trialPeriodDays = 14;
        if (this.trialPeriod == "Days7") this.trialPeriodDays = 7;
        AuthenticatorService.createSubscription(
          "Quest",
          this.email,
          this.password,
          this.firstName,
          this.lastName,
          this.firstNameOnCard,
          this.lastNameOnCard,
          this.ccNumber,
          this.cvv,
          this.expirationMonth,
          this.expirationYear,
          this.trialPeriodDays
        )
          .then(response => {
            console.log("TCL: createSubscription -> response", response);
            this.$store.commit("SET_LOADING_STATUS_NODELAY", false);
            this.activeStep = 4;
          })
          .catch(error => {
            this.$store.commit("SET_LOADING_STATUS_NODELAY", false);
            if (error && error.response && error.response.data)
              this.showError(error.response.data);
            else this.showError(error);
          });
      }
    },

    isMember(email) {
      this.$store.commit("SET_LOADING_STATUS_NODELAY", true);
      this.validEmail = false;
      AuthenticatorService.isMember(email).then(response => {
        if (response.data == true) {
          this.validEmail = true;
          AuthenticatorService.productStatus(email, "Quest")
            .then(response => {
              this.activeStep = 1;
              this.productStatus = response.data;

              if (this.productStatus.nextCall == "SignIn") {
                this.visibleSteps.signUp = false;
                this.visibleSteps.reactivate = false;
                this.visibleSteps.resume = false;
                this.visibleSteps.confirmation = false;
                this.visibleSteps.signIn = true;
                this.activeStep = 5;
              }
              if (this.productStatus.nextCall == "Reactivate") {
                this.visibleSteps.signUp = false;
                this.visibleSteps.reactivate = true;
                this.visibleSteps.resume = false;
                this.visibleSteps.confirmation = true;
                this.visibleSteps.signIn = false;
                this.activeStep = 2;
              }
              if (this.productStatus.nextCall == "Resume") {
                this.visibleSteps.signUp = false;
                this.visibleSteps.reactivate = false;
                this.visibleSteps.resume = true;
                this.visibleSteps.confirmation = true;
                this.visibleSteps.signIn = false;
                this.activeStep = 3;
              }
              this.$store.commit("SET_LOADING_STATUS_NODELAY", false);
            })
            .catch(error => {
              this.$store.commit("SET_LOADING_STATUS_NODELAY", false);
              if (error && error.response && error.response.data)
                this.showError(error.response.data);
              else this.showError(error);
            });
        } else {
          this.$store.commit("SET_LOADING_STATUS_NODELAY", false);
          this.showError(
            "We couldn't find " +
              email +
              ". Please try a different email or check the spelling."
          );
        }
      });
    },

    passwordCheck($v) {
      if (
        (!$v.password.required || !$v.password.minLength) &&
        $v.password.$error
      )
        return "true";
      else return "false";
    },

    reactivate() {
      this.$store.commit("SET_LOADING_STATUS_NODELAY", true);
      AuthenticatorService.reactivateProduct(
        this.emailToValidate,
        this.passwordToValidate,
        "Quest"
      )
        .then(response => {
          console.log("TCL: reactivate -> response", response);
          this.$store.commit("SET_LOADING_STATUS_NODELAY", false);
          this.activeStep = 4;
        })
        .catch(error => {
          this.$store.commit("SET_LOADING_STATUS_NODELAY", false);
          if (error && error.response && error.response.data)
            this.showError(error.response.data);
          else this.showError(error);
        });
    },

    resetSteps() {
      this.visibleSteps.signUp = true;
      this.visibleSteps.reactivate = false;
      this.visibleSteps.resume = false;
      this.visibleSteps.confirmation = true;
      this.visibleSteps.signIn = false;
      this.activeStep = 0;
    },

    resume() {
      this.$store.commit("SET_LOADING_STATUS_NODELAY", true);
      AuthenticatorService.resumeProduct(
        this.emailToValidate,
        this.passwordToValidate,
        "Quest"
      )
        .then(response => {
          console.log("TCL: resume -> response", response);
          this.$store.commit("SET_LOADING_STATUS_NODELAY", false);
          this.activeStep = 4;
        })
        .catch(error => {
          console.log("TCL: resume -> error", error);
          this.$store.commit("SET_LOADING_STATUS_NODELAY", false);
          this.showError("The password didn't match, please try again.");
        });
    },

    signin() {
      // Make sure we are not authenticated.
      this.$store.commit("CLEAR_SESSION");

      // Navigate to the web site for sign in.
      this.$router.push("properties");
    }
  },

  mounted() {
    console.log("trial", this.$route.query.trial);
    this.$store.state.isLoginRequired = false;
    if (this.$route.query.trial == "Days14") {
      this.trialPeriod = "Days14";
      this.trialEndDate = moment()
        .add(14, "days")
        .calendar();
    } else this.trialPeriod = "";
  },

  beforeDestroy() {
    this.$store.state.isLoginRequired = true;
  }
};
</script>

<style>
@import "/bulma-divider/dist/css/bulma-divider.min.css";
</style>
